export const payrollsConfigRoutes = [
  {
    path: '/payrollsConfig',
    name: 'payrollsConfig',
    component: () => import('./views/ListPayrollsConfig.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/add',
    name: 'payrollsConfig/add',
    component: () => import('./views/CreatePayrollConfig.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id',
    name: 'payrollsConfig/detail',
    component: () => import('./views/PayrollConfigDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
